/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Loading from "vux/src/components/loading/index.vue"; // this line is trasformed by vux-loader
import { mapState } from 'vuex';
import QsyFileUpload from './CustomFormList/QsyFileUpload';
export default {
  components: {
    Previewer: Previewer,
    Loading: Loading,
    QsyFileUpload: QsyFileUpload
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    title: {
      type: String,
      default: i18n.tc("381")
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    num: {
      type: Number,
      default: 9
    },
    hiddenBorder: {
      type: Boolean,
      default: false
    },
    hiddenUpload: {
      type: Boolean,
      default: false
    },
    hiddenDelete: {
      type: Boolean,
      default: false
    },
    waterMask: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      loadingShow: false,
      hasTitleSlot: false,
      progress: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['RUN_ENV'])), {}, {
    imgUrlsForPreviewer: function imgUrlsForPreviewer() {
      return this.currValue.map(function (item) {
        return {
          src: item
        };
      });
    },
    isUpperLimit: function isUpperLimit() {
      return this.currValue.length === this.num;
    }
  }),
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    clickUpload: function clickUpload() {
      this.$vux.toast.text("\u56FE\u7247\u6700\u591A".concat(this.num, i18n.tc("481")));
      // if (this.currValue.length === this.num) {
      //   this.$vux.toast.text(`图片最多${this.num}张`)
      // } else {
      //   // _this.$vux.toast.text('上传成功')
      //   this.$refs.qsyFileUpload.upload()
      // }
    },
    finish: function finish(e) {
      this.loadingShow = false;
      if (e.currentTarget.status === 200) {
        var res = JSON.parse(e.currentTarget.response);
        if (res) {
          if (res.success) {
            this.currValue = this.currValue.concat(res.data.fileUrl + res.data.files);
          } else {
            this.$vux.toast.text(res.message);
          }
        } else {
          console.error('上传出错，请重试。。。');
        }
      } else {
        console.error(e.currentTarget.statusText);
      }
    },
    deleteImg: function deleteImg(index) {
      this.currValue.splice(index, 1);
    },
    imgClick: function imgClick(index) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.previewer.show(index);
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};